import { AlertCircle, CheckCircle } from "lucide-react";
import { useParams } from "react-router-dom";
import { useScannerScannedAttendees } from "../hooks";
const formatCheckedInTime = (value: string): string =>
  value
    ? new Date(value).toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
    : "";

const ScannedAttendeesTab = () => {
  const { id: eventId } = useParams<{ id: string }>();
  const { attendees, error, isLoading, refetch } = useScannerScannedAttendees(eventId);

  if (isLoading)
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] px-6">
        <div className="w-8 h-8 border-2 border-[#00C49A] border-t-transparent rounded-full animate-spin" />
        <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">Loading attendees...</p>
      </div>
    );
  if (error)
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] px-6">
        <AlertCircle
          size={48}
          className="text-red-400 mb-4"
        />
        <p className="text-base font-medium text-gray-700 dark:text-gray-300">
          Failed to load attendees
        </p>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 text-center">{error}</p>
        <button
          onClick={() => void refetch()}
          className="mt-4 px-4 py-2 bg-[#00C49A] dark:bg-emerald-500 text-white rounded-lg font-medium"
        >
          Try Again
        </button>
      </div>
    );
  if (attendees.length === 0)
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] px-6">
        <p className="text-base font-medium text-gray-500 dark:text-gray-400">
          No attendees scanned yet
        </p>
        <p className="mt-2 text-sm text-gray-400 dark:text-gray-500 text-center">
          Start scanning QR codes to check in guests
        </p>
      </div>
    );

  return (
    <div className="p-[14px] bg-[#F9FAFB] dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 rounded-[10px]">
        {attendees.map((attendee, index) => (
          <div
            key={`${index}-${attendee.email}`}
            className={`flex items-start justify-between p-[14px] ${index < attendees.length - 1 ? "border-b border-gray-200 dark:border-gray-700" : ""}`}
          >
            <div className="flex-1 min-w-0 pr-4">
              <p className="font-semibold text-gray-900 dark:text-white text-base truncate">
                {attendee.name}
              </p>
              {attendee.email && (
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5 truncate">
                  {attendee.email}
                </p>
              )}
            </div>
            <div className="flex flex-col items-end flex-shrink-0">
              <CheckCircle
                size={20}
                className="text-[#00C49A] dark:text-emerald-400"
              />
              <span className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                {formatCheckedInTime(attendee.checked_in_at)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScannedAttendeesTab;
